import React from "react"
import Image from "./Image";
import { InlineSvg } from "./Svg"

export default ({img = false, svg = false}) => (<div className="icon">
  {img && (<Image modifier='icon' img={img} />)}
  {svg && (<InlineSvg viewBox={svg.viewBox} markup={svg.markup} />)}
</div>);